import { ClassesType } from '../../Classes.types';
import DefaultScreen from '../../DefaultScreen';
import { Grid, Box, Typography, Button } from '@material-ui/core';
import {
	APICreateGroupData,
	ApiCreateGroupPayload,
	ApiSaveCampaignSettingsData,
	ApiSaveCampaignSettings,
	ApiSendCampaign,
	campaignSettingsData,
	campaignSettingsPayloadData,
	createCombinedGroupData,
	selectedFilterCampaignsProps,
	smsReducerProps,
	specialDateDropDownData,
	testGroupDataProps,
	uploadClientDataPayload,
	uploadClientData,
	uploadData,
	whatsappCampaignNameFilterData,
	WhatsappCampaignSecondProps,
	ApiGetCampaignSummary,
	ApiGetCampaignSummaryPayloadData,
	phoneNumberAPIProps,
	GetTestGroups,
	ApiSendCampaignData,
	coreProps,
	CampaignDetailById,
} from './Types/WhatsappCampaign.types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import RightPane from './Components/RightPane';
import LeftPane from './Components/LeftPane';
import { BaseSyntheticEvent, useEffect, useMemo, useRef, useState } from 'react';
import SummaryModal from './Popups/SummaryModal';
import Buttons from './Components/Buttons';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import moment from 'moment';
import Toast from '../../../components/Toast/Toast.component';
import {
	addRecipient,
	addRecipients,
	createCombinedGroup,
	createGroup,
	deleteCampaign,
	getAccountExtraData,
	getCampaignDetailById,
	getCampaignSettings,
	getWhatsAppCampaignSummary,
	getWhatsappCampaignNameFilter,
	saveCampaignSettings,
	sendCampaign,
	userPhoneNumbers,
} from '../../../redux/reducers/whatsappSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from '../../../components/Loader/Loader';
import {
	apiStatus,
	buttons,
	resetToastData,
	tabs,
	whatsappRoutes,
	tierSetting,
} from '../Constant';
import { getTestGroups } from '../../../redux/reducers/smsSlice';
import { getGroupsByIds } from '../../../redux/reducers/groupSlice';
import { PagedGroupsFilter } from '../../../hooks/useServerPagedGroups';
import {
	fetchGroupSelection,
	makeFetchGroupsPage,
} from '../../../helpers/Groups/pagedGroups';
import {
	commonAPIResponseProps,
	toastProps,
} from '../Editor/Types/WhatsappCreator.types';
import { useNavigate, useParams } from 'react-router-dom';
import { findPlanByFeatureCode } from '../../../redux/reducers/TiersSlice';
import SendCampaignSuccess from './Popups/SendCampaignSuccess';
import NoSetup from '../NoSetup/NoSetup';
import { specialDateDropDownPayload } from './Types/WhatsappCampaign.types';
import { Title } from '../../../components/managment/Title';
import { BaseDialog } from '../../../components/DialogTemplates/BaseDialog';
import { sitePrefix } from '../../../config';
import { SelectChangeEvent, Stack } from '@mui/material';
import ConfirmationButtons from '../../../components/ConfirmationButtons/ConfirmationButtons';
import { DateFormats, TierFeatures } from '../../../helpers/Constants';
import Pulse from '../../../components/Pulse/Pulse';
import TierPlans from '../../../components/TierPlans/TierPlans';
import { get } from 'lodash';

const SendCampaign = ({
	classes,
}: ClassesType & WhatsappCampaignSecondProps) => {
	const { t: translator } = useTranslation();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const queryParams = new URLSearchParams(window.location.search)
	let FromAutomation = queryParams.get("FromAutomation") || false
	if (FromAutomation === 'false') FromAutomation = false;
	const NodeToEdit = queryParams.get("NodeToEdit") || false
	let isSendCampaign = queryParams.get("new") || false
	if (isSendCampaign === 'false') isSendCampaign = false;

	const { campaignID } = useParams();
	const { isRTL } = useSelector((state: { core: coreProps }) => state.core);
	const { testGroups: testGroupList } = useSelector(
		(state: { sms: smsReducerProps }) => state.sms
	);
	const ToastMessages = useSelector(
		(state: { whatsapp: { ToastMessages: toastProps } }) =>
			state.whatsapp.ToastMessages
	);
	const { currentPlan, availablePlans } = useSelector((state: any) => state.tiers);
	const { subAccount } = useSelector((state: any) => state.common);
	const [showTestGroups, setShowTestGroups] = useState<boolean>(false);
	const [selectedGroups, setSelectedGroups] = useState<testGroupDataProps[]>(
		[]
	);
	const [selectedFilterCampaigns, setFilterCampaigns] = useState<
		selectedFilterCampaignsProps[]
	>([]);
	const [selectedFilterGroups, setFilterGroups] = useState<
		testGroupDataProps[]
	>([]);
	const [sendDate, handleSendDate] = useState<MaterialUiPickersDate | null>(
		null
	);
	const [sendTime, setsendTime] = useState<MaterialUiPickersDate | null>(null);
	const [sendType, setSendType] = useState<string>('1');
	const [model, setModel] = useState<{}>({ ID: 0 });
	const [isSpecialDateBefore, setIsSpecialDateBefore] = useState<boolean>(true);
	const [timePickerOpen, setTimePickerOpen] = useState<boolean>(false);
	const [toastMessage, setToastMessage] =
		useState<toastProps['SUCCESS']>(resetToastData);
	const [daysBeforeAfter, setdaysBeforeAfter] = useState<string>('');
	const [spectialDateFieldID, setDateFieldID] = useState<string>('0');
	const [newGroupName, setNewGroupName] = useState<string>('');

	const [activeTab, setActiveTab] = useState<'group' | 'manual'>(tabs.GROUP);
	const [groupSendValidationErrors, setGroupSendValidationErrors] = useState<
		string[]
	>([]);
	const [isAccountSetup, setIsAccountSetup] = useState<boolean | null>(null);
	const [isLoader, setIsLoader] = useState<boolean>(true);
	const [isCreateNewGroup, setIsCreateNewGroup] = useState<boolean>(false);
	const [TierMessageCode, setTierMessageCode] = useState<string>("");

	// PR-3790: bumping this makes the paged group pickers re-fetch from page 1,
	// after a group is created or clients are uploaded into one.
	const [groupsReloadToken, setGroupsReloadToken] = useState<number>(0);
	// PR-3790: null means "sum it from selectedGroups"; a number is the server's
	// select-all total, needed because that selection holds ids rather than objects.
	const [selectionTotalRecipients, setSelectionTotalRecipients] = useState<
		number | null
	>(null);
	const [exceptionalDaysToggle, setExceptionalDaysToggle] =
		useState<boolean>(false);
	const [exceptionalDays, setExceptionalDays] = useState<string>('');
	const [randomlyCount, setRandomlyCount] = useState<string>('');

	const [specialDatedropDown, setSpecialDatedropDown] =
		useState<specialDateDropDownPayload>();
	// Whether the campaign name list has already been fetched this session.
	// See ensureFilterCampaigns.
	const campaignsFetched = useRef<boolean>(false);
	const [finishedCampaigns, setFinishedCampaigns] = useState<
		selectedFilterCampaignsProps[]
	>([]);
	const [campaignSummary, setCampaignSummary] =
		useState<ApiGetCampaignSummaryPayloadData>();
	const [dialogType, setDialogType] = useState<any>({
		type: '',
		data: ''
	});
	const [mediaOverrideUrl, setMediaOverrideUrl] = useState<string | undefined>(undefined);
	const [showTierPlans, setShowTierPlans] = useState(false);
	
	const [ pulseData, setPulseData ] = useState({
		pulseSettingsId: 0,
		pulseAmount: 0,
		timeInterval: 0,
		pulseType: 2,
		random: 0,
		timeType: 1,
		pulsePer: "recipients",
		pulseReci: "",
		minName: "mins",
		hourName: "Hours",
		togglePulse: false,
		toggleRandom: false,
		pulsesOpen: false
	});
	
	useEffect(() => {
		(async () => {
			setIsLoader(true);
			const { payload: phoneNumberData }: phoneNumberAPIProps =
				await dispatch<any>(userPhoneNumbers());
			if (
				phoneNumberData?.Status === apiStatus.SUCCESS &&
				phoneNumberData?.Data &&
				phoneNumberData?.Data?.length > 0
			) {
				/**
				 * testGroupList is for fetching all test groups across the platform
				 * Here testGroupList is we are taking from existing code and we don't
				 * know what is the initial value that is the reason we kept it here in
				 * if condition
				 */
				checkCampaignID();
				if (!testGroupList || testGroupList?.length === 0) {
					await dispatch(getTestGroups());
				}
				// PR-3790: neither the group list nor the campaign name list is fetched
				// here any more - the picker pages its own, and the name list waits for the
				// filter dialog. Saved selections are resolved by id in getCampaignSettingData.
				(async () => {
					setIsLoader(true);
					getSpecialDateDropDown();
					getCampaignSettingData();
				})();
				setIsAccountSetup(true);
			} else {
				setIsLoader(false);
				setIsAccountSetup(false);
			}
		})();
		/**
		 * we disable it because we want to run this code only when component loads
		 */
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const checkCampaignID = () => {
		if (!campaignID) {
			navigate(whatsappRoutes.CREATE_CAMPAIGN_PAGE1);
		}
	};

	const getFilterCampaign = async () => {
		if (campaignID) {
			const {
				payload: whatsappCampaignNameFilterData,
			}: whatsappCampaignNameFilterData = await dispatch<any>(
				getWhatsappCampaignNameFilter(campaignID)
			);
			if (whatsappCampaignNameFilterData?.Status === apiStatus.SUCCESS) {
				setFinishedCampaigns(whatsappCampaignNameFilterData?.Data);
				campaignsFetched.current = true;
				return whatsappCampaignNameFilterData?.Data;
			}
			campaignsFetched.current = true;
			return [];
		}
		return [];
	};

	/**
	 * Fetches the campaign name list at most once, on demand.
	 *
	 * Called when the recipient filter dialog opens, so accounts that never open
	 * it never pay for the call. A ref rather than state because two rapid opens
	 * must not both fire the request, and the value is never rendered.
	 */
	const ensureFilterCampaigns = async () => {
		if (campaignsFetched.current) return;
		campaignsFetched.current = true;
		await getFilterCampaign();
	};

	const getSpecialDateDropDown = async () => {
		const { payload: specialDateDropDownData }: specialDateDropDownData =
			await dispatch<any>(getAccountExtraData());
		setSpecialDatedropDown(specialDateDropDownData);
		// if (specialDateDropDownData) {
		// 	let finalDropDownData: string[] = [];
		// 	Object.keys(specialDateDropDownData)?.forEach((specialDayKey) => {
		// 		if (
		// 			specialDayKey?.toLowerCase()?.includes('extradate') &&
		// 			specialDateDropDownData[specialDayKey]?.length > 0
		// 		) {
		// 			finalDropDownData.push(specialDateDropDownData[specialDayKey]);
		// 		}
		// 	});
		// 	setSpecialDatedropDown(finalDropDownData);
		// }
	};

	const setSendSetting = (
		SendTypeID: number,
		FutureDateTime: string | null,
		SpecialSettings: campaignSettingsPayloadData['SpecialSettings']
	) => {
		if (SendTypeID === 2 && FutureDateTime) {
			handleSendDate(moment(FutureDateTime));
		} else if (SendTypeID === 3 && SpecialSettings) {
			setdaysBeforeAfter(SpecialSettings?.Day?.toString() || '');
			setsendTime(moment(SpecialSettings?.SendHour));
			setIsSpecialDateBefore(
				SpecialSettings?.IntervalTypeID === -1 ? true : false
			);
			setDateFieldID(SpecialSettings?.DateFieldID?.toString() || '0');
		}
	};

	const getCampaignSettingData = async () => {
		if (campaignID) {
			const { payload: campaignSettings }: campaignSettingsData =
				await dispatch<any>(getCampaignSettings(campaignID));
			setIsLoader(false);
			let apiGroups = campaignSettings?.Data?.Groups;
			let apiFilterGroups = campaignSettings?.Data?.SendExeptional?.Groups;
			let apiFilterCampaigns =
				campaignSettings?.Data?.SendExeptional?.Campaigns;
			let SendTypeID = campaignSettings?.Data?.SendTypeID;
			if (SendTypeID === 1 || SendTypeID === 2 || SendTypeID === 3) {
				setSendType(campaignSettings?.Data?.SendTypeID?.toString());
			} else {
				setSendType('1');
			}
			setSendSetting(
				campaignSettings?.Data?.SendTypeID,
				campaignSettings?.Data?.FutureDateTime,
				campaignSettings?.Data?.SpecialSettings
			);
			// PR-3790: saved selection resolved by id, not by filtering a downloaded list.
			{
				let testGroups = testGroupList;
				// will fetch test group if not available
				if (!testGroupList || testGroupList?.length === 0) {
					const { payload: updatedtestGroups }: GetTestGroups =
						await dispatch<any>(getTestGroups());
					if (updatedtestGroups?.length > 0) {
						testGroups = updatedtestGroups;
					}
				}
				// Test groups come from their own endpoint, so they are matched
				// locally and excluded from the by-id request.
				const selectedTestGroups =
					testGroups?.filter((groupData) =>
						apiGroups?.includes(Number(groupData?.GroupID))
					) || [];
				if (selectedTestGroups.length > 0) {
					setShowTestGroups(true);
				}

				const testGroupIds = new Set(
					(testGroups || []).map((g) => Number(g?.GroupID))
				);
				const normalGroupIds = (apiGroups || [])
					.map((id: number) => Number(id))
					.filter((id: number) => !testGroupIds.has(id));

				const selectedNormalGroups = await fetchGroupsByIds(normalGroupIds);

				setSelectedGroups([...selectedNormalGroups, ...selectedTestGroups]);
				// A restored selection is an explicit set of groups, so the total is
				// summed from them rather than taken from a select-all response.
				setSelectionTotalRecipients(null);

				setFilterGroups(
					await fetchGroupsByIds(
						(apiFilterGroups || []).map((id: number) => Number(id))
					)
				);
			}
			// Only fetch the campaign name list when this campaign actually has
			// excluded campaigns saved. Their names have to be resolved to show
			// them, and there is no fetch-campaigns-by-id endpoint - so without
			// this the user's saved "do not send to" selection would come back
			// empty. Campaigns with nothing excluded skip the call entirely and
			// pick it up later if the filter dialog is opened.
			if (apiFilterCampaigns && apiFilterCampaigns.length > 0) {
				const campaignsData = await getFilterCampaign();
				setFilterCampaigns(
					campaignsData?.filter((campaign) =>
						apiFilterCampaigns?.includes(Number(campaign?.WACampaignID))
					)
				);
			}
			if (campaignSettings?.Data?.SendExeptional?.ExceptionalDays) {
				setExceptionalDays(
					campaignSettings?.Data?.SendExeptional?.ExceptionalDays?.toString()
				);
				setExceptionalDaysToggle(true);
			}

			const {
				PulseSettings,
				RandomSettings
			} = campaignSettings?.Data;
			if (PulseSettings !== null && RandomSettings !== null) {
				setPulseData({
					pulseSettingsId: PulseSettings?.PulseSettingsId || 0,
					pulseAmount: PulseSettings?.PulseAmount || 0,
					timeInterval: PulseSettings?.TimeInterval || 0,
					pulseType: PulseSettings?.PulseType || 0,
					random: RandomSettings?.RandomAmount || 0,
					timeType: PulseSettings?.TimeType || 0,
					pulsePer: PulseSettings?.PulseType === 2 ? "recipients" : "percent",
					pulseReci: PulseSettings?.PulseType === 2 ? "Recipients" : "",
					minName: PulseSettings?.TimeType === 1 ? "mins" : "",
					hourName: PulseSettings?.TimeType === 2 ? "Hours" : "",
					togglePulse: PulseSettings?.PulseSettingsId !== -1 ? true : false,
					toggleRandom: RandomSettings?.RandomAmount !== 0 ? true : false,
					pulsesOpen: false
				})
			}

			const { payload: campaignData }: CampaignDetailById =
				await dispatch<any>(getCampaignDetailById(campaignID));
			if (campaignData?.Status === apiStatus.SUCCESS) {
				const mediaEntry = campaignData?.Data?.VariableValues?.find(
					(v: any) => v.FieldTypeId === -1
				);
				if (mediaEntry?.VariableValue) {
					setMediaOverrideUrl(mediaEntry.VariableValue);
				}
			}
		}
	};

	const handleDatePicker = (value: MaterialUiPickersDate | null) => {
		handleSendDate(moment(value));
	};

	const handleRadioTime = (value: MaterialUiPickersDate | null) => {
		setsendTime(value);
	};

	const handleSendType = (event: BaseSyntheticEvent) => {
		if (event.target.value === '1') {
			setModel({ ...model, SendDate: null });
			handleSendDate(null);
		} else if (event.target.value === '3') {
			setModel({ ...model, SendDate: null });
			handleSendDate(null);
		}
		setSendType(event.target.value);
	};

	const handleTimePicker = (value: MaterialUiPickersDate | null) => {
		let date = moment(sendDate);
		let time = moment(value, 'HH:mm');

		date.set({
			hour: time.get('hour'),
			minute: time.get('minute'),
		});

		if (date < moment()) {
			date = moment();
			setToastMessage(ToastMessages.DATE_PASS);
		}

		handleSendDate(date);
		setTimePickerOpen(false);
	};

	const handleSpecialDayChange = (e: BaseSyntheticEvent) => {
		const re = /^[0-9\b]+$/;
		if (
			(e.target.value === '' || re.test(e.target.value)) &&
			Number(e.target.value <= 999)
		) {
			setdaysBeforeAfter(e.target.value);
		}
	};

	const handleSelectChange = (e: SelectChangeEvent) => {
		if (e.target.value === '0') {
			setDateFieldID('0');
		} else {
			setDateFieldID(e.target.value);
		}
	};

	const onCampaignSave = async (
		showMessage: boolean = true,
		isLoading: boolean = false,
		isValidate: boolean = true,
		ApiSelectedGroups: testGroupDataProps[] = selectedGroups
	) => {
		if (isValidate === true ? validateSendSetting() : true) {
			let saveCampaignSettingsPayload: ApiSaveCampaignSettingsData = {
				WACampaignID: Number(campaignID),
				SendTypeID: Number(sendType),
				Groups: ApiSelectedGroups?.map((group) => group.GroupID),
				SendExeptional: {
					IsExceptionalGroups: selectedFilterGroups?.length > 0 ? true : false,
					Groups: selectedFilterGroups?.map((group) => group.GroupID),
					IsExceptionSmsCampaigns:
						selectedFilterCampaigns?.length > 0 ? true : false,
					Campaigns: selectedFilterCampaigns?.map(
						(campaign) => campaign.WACampaignID
					),
					ExceptionalDays: exceptionalDaysToggle ? Number(exceptionalDays) : 0,
				},
				PulseSettings: {
					PulseSettingsId: pulseData.pulseSettingsId,
					PulseAmount: pulseData.pulseAmount,
					PulseType: pulseData.pulseType,
					TimeInterval: pulseData.timeInterval,
					TimeType: pulseData.timeType
				},
				RandomSettings: {
					RandomAmount: pulseData.random
				}
			};
			if (sendType === '2') {
				saveCampaignSettingsPayload['FutureDateTime'] = `${moment(sendDate)
					.locale('en')
					.format('YYYY-MM-DD hh:mm:ss a')}`;
			}
			if (sendType === '3') {
				saveCampaignSettingsPayload['specialsettings'] = {
					datefieldid: Number(spectialDateFieldID),
					day: Number(daysBeforeAfter),
					intervaltypeid: isSpecialDateBefore ? -1 : 1,
					sendhour: moment(sendTime).locale('en').format('YYYY-MM-DD hh:mm a'),
				};
			}
			isLoading && setIsLoader(true);
			const { payload: saveCampaignSettingData }: ApiSaveCampaignSettings =
				await dispatch<any>(saveCampaignSettings(saveCampaignSettingsPayload));
			setIsLoader(false);
			if (saveCampaignSettingData.Status === apiStatus.SUCCESS) {
				if (showMessage) {
					setToastMessage(ToastMessages.CAMPAIGN_SAVE_SUCCESS);
				}
				return saveCampaignSettingData?.Status;
			} else {
				saveCampaignSettingData?.Message
					? setToastMessage({
						...ToastMessages.ERROR,
						message: saveCampaignSettingData?.Message,
					})
					: setToastMessage(ToastMessages.ERROR);
				return apiStatus?.ERROR;
			}
		}
	};

	const onCampaignSend = async () => {
		if (validateSendSetting() && campaignID) {
			const saveCampaignData = await onCampaignSave(false, true, true);
			setIsLoader(true);
			let { payload: campaignSummaryData }: ApiGetCampaignSummary =
				await dispatch<any>(getWhatsAppCampaignSummary(campaignID));
			if (saveCampaignData === apiStatus.SUCCESS) {
				if (campaignSummaryData.Status === apiStatus.SUCCESS) {
					if (campaignSummaryData?.Data?.FinalCount > 0) {
						setCampaignSummary(campaignSummaryData?.Data);
						if (
							campaignSummaryData.Data.WhatsappTierID === 1 ||
							campaignSummaryData.Data.WhatsappTierID === 2 ||
							campaignSummaryData.Data.WhatsappTierID === 3
						) {
							if (
								campaignSummaryData?.Data?.WhatsappSmsLeft > 0 ||
								(sendType === '2' &&
									moment(sendDate).diff(moment(), 'seconds') > 86400) ||
								sendType === '3'
							) {
								setDialogType({
									type: 'summary',
									overrideMediaUrl: mediaOverrideUrl,
								})
							} else {
								setDialogType({
									type: 'exceedDailyLimit'
								})
							}
						} else {
							setDialogType({
								type: 'summary',
								overrideMediaUrl: mediaOverrideUrl,
							})
						}
					} else {
						setToastMessage({
							...ToastMessages.ERROR,
							message: translator('whatsappCampaign.noRecipient'),
						});
					}
				} else {
					campaignSummaryData?.Message
						? setToastMessage({
							...ToastMessages.ERROR,
							message: campaignSummaryData?.Message,
						})
						: setToastMessage(ToastMessages.ERROR);
				}
			}
		}
		setIsLoader(false);
	};

	const onDeleteCampaign = async () => {
		setDialogType({ type: '', data: '' })
		if (campaignID) {
			const deleteData: commonAPIResponseProps = await dispatch<any>(
				deleteCampaign(campaignID)
			);
			if (deleteData?.payload?.Status === apiStatus.SUCCESS) {
				setToastMessage(ToastMessages.DELETE_CAMPAIGN_SUCCESS);
				setTimeout(() => {
					navigate(whatsappRoutes.CAMPAIGN_MANAGEMENT);
				}, 1000);
			} else {
				deleteData?.payload?.Message
					? setToastMessage({
						...ToastMessages.ERROR,
						message: deleteData?.payload?.Message,
					})
					: setToastMessage(ToastMessages.ERROR);
			}
		}
	};

	const onFormButtonClick = async (buttonName: string) => {
		switch (buttonName) {
			case buttons.DELETE:
				setDialogType({
					type: 'delete'
				})
				break;
			case buttons.EXIT:
				setDialogType({
					type: 'exit'
				})
				break;
			case buttons.SAVE:
				onCampaignSave(true, true, true);
				break;
			case buttons.SEND:
				onCampaignSend();
				break;
			case buttons.CONTINUE:
				if (!!FromAutomation && !isSendCampaign) {
					const saveCampaignData = await onCampaignSave(true, true, true);
					if (saveCampaignData === apiStatus.SUCCESS) {
						window.location.href = `/Pulseem/CreateAutomations.aspx?AutomationID=${FromAutomation}&NodeToEdit=${NodeToEdit}&fromreact=true&Culture=${isRTL ? 'he-IL' : 'en-US'}`
					}
				}
				break;

			default:
				break;
		}
	};

	const resetToast = () => {
		setToastMessage(resetToastData);
	};

	const renderToast = () => {
		if (toastMessage && toastMessage.message !== '') {
			setTimeout(() => {
				resetToast();
			}, 4000);
			return <Toast data={toastMessage} />;
		}
		return null;
	};

	const onNewGroupSave = async () => {
		if (newGroupName?.length > 0) {
			const combinedGroupPayload = {
				SubAccountID: 1,
				GroupName: newGroupName,
				GroupIds: selectedGroups?.map(
					(group: testGroupDataProps) => group.GroupID
				),
			};
			setIsLoader(true);
			const { payload: createdGroupData }: createCombinedGroupData =
				await dispatch<any>(createCombinedGroup(combinedGroupPayload));
			if (createdGroupData) {
				// PR-3790: tell the paged picker to re-fetch rather than pulling
				// the whole group list down again.
				setGroupsReloadToken((token) => token + 1);

				if (createdGroupData?.GroupID) {
					setSelectedGroups([createdGroupData]);
					setNewGroupName('');
					setIsCreateNewGroup(false);
				}
				await onCampaignSave(false, false, false, [createdGroupData]);
				setToastMessage(ToastMessages.GROUP_CREATED_SUCCESS);
			} else {
				setToastMessage(ToastMessages.ERROR);
			}
			setIsLoader(false);
		} else {
			setIsLoader(false);
			setGroupSendValidationErrors([
				translator('whatsappCampaign.groupNameRequired'),
			]);
			setDialogType({
				type: 'validation'
			})
		}
	};

	const onFilter = () => {
	};

	/** PR-3790: one page of groups. Passing this to the picker turns paging on. */
	const fetchGroupsPage = useMemo(() => makeFetchGroupsPage(dispatch), [dispatch]);

	/** PR-3790: a manual change invalidates the server's select-all total. */
	const setSelectedGroupsManually = (updated: testGroupDataProps[]) => {
		setSelectedGroups(updated);
		setSelectionTotalRecipients(null);
	};

	/**
	 * PR-3790: "select all" asks the server for every matching group (id, name, recipients)
	 * plus a total. The saved payload is still a plain id array, so nothing downstream changes.
	 */
	const onSelectAllGroups = async (
		selectAll: boolean,
		filter?: PagedGroupsFilter,
		extraGroups?: testGroupDataProps[]
	) => {
		if (!selectAll) {
			setSelectedGroups([]);
			setSelectionTotalRecipients(null);
			return;
		}

		// Test groups are pinned rather than paged, so they arrive as objects and
		// are added on top of the groups the server returns.
		const pinned = extraGroups || [];
		const pinnedRecipients = pinned.reduce(
			(sum: number, group: testGroupDataProps) =>
				sum + (Number(group?.Recipients) || 0),
			0
		);

		setIsLoader(true);
		try {
			const selection = await fetchGroupSelection(dispatch, filter);
			setSelectedGroups([
				...(selection.groups as testGroupDataProps[]),
				...pinned,
			]);
			setSelectionTotalRecipients(selection.totalRecipients + pinnedRecipients);
		} finally {
			setIsLoader(false);
		}
	};

	/** PR-3790: summed from the selection, or server-supplied after "select all". */
	const totalRecipients =
		selectionTotalRecipients !== null
			? selectionTotalRecipients
			: (selectedGroups || []).reduce(
					(sum: number, group: testGroupDataProps) =>
						sum + (Number(group?.Recipients) || 0),
					0
			  );

	/**
	 * PR-3790: resolves group ids to full rows. Without this a reopened campaign's saved
	 * selection comes back silently empty, since the full list is no longer downloaded.
	 */
	const fetchGroupsByIds = async (
		ids: number[]
	): Promise<testGroupDataProps[]> => {
		if (!ids || ids.length === 0) return [];
		const { payload } = await dispatch<any>(getGroupsByIds(ids));
		return payload?.Groups || [];
	};

	const onManualUpload = async (
		groupName: string,
		uploadData: uploadData,
		uploadedAsFile: boolean
	) => {
		setIsLoader(true);
		let requestPayload: ApiCreateGroupPayload = {
			GroupName: groupName,
			IsTestGroup: false,
		};
		let uploadClientData: uploadClientData;
		const { payload: createGroupData }: APICreateGroupData =
			await dispatch<any>(createGroup(requestPayload));
		if (createGroupData?.StatusCode === 201 && createGroupData?.Message) {
			if (uploadedAsFile) {
				// If data is more than 5000 rows we will upload as single file
				// To upload data method will be **addRecipients**
				uploadClientData = await dispatch<any>(
					addRecipients({
						...uploadData,
						GroupIds: [Number(createGroupData?.Message)],
					})
				);
				setIsLoader(false);
			} else {
				// If data is less than 5000 rows we will upload data in format of JSON
				// To upload data method will be **addRecipient**
				uploadClientData = await dispatch<any>(
					addRecipient({
						...uploadData,
						GroupIds: [Number(createGroupData?.Message)],
					})
				);
				setIsLoader(false);
			}
			handleAddClientsResponse(
				uploadClientData?.payload,
				createGroupData?.Message
			);
		} else {
			setIsLoader(false);
			createGroupData?.Message
				? setToastMessage({
					...ToastMessages.ERROR,
					message: createGroupData?.Message,
				})
				: setToastMessage(ToastMessages.ERROR);
		}
	};

	const handleAddClientsResponse = async (
		res: uploadClientDataPayload,
		groupID: string
	) => {
		switch (res?.StatusCode) {
			case 201: {
				setToastMessage(ToastMessages.UPLOAD_CLIENT_DATA_SUCEESS);
				setActiveTab('group');
				setIsLoader(true);
				// PR-3790: ask for just the group that was uploaded into, instead
				// of re-downloading every group to find it.
				setGroupsReloadToken((token) => token + 1);
				const [latestAddedGroup] = await fetchGroupsByIds([Number(groupID)]);
				setIsLoader(false);
				if (latestAddedGroup) {
					setSelectedGroups([...selectedGroups, latestAddedGroup]);
					await onCampaignSave(false, false, false, [
						...selectedGroups,
						latestAddedGroup,
					]);
				}
				break;
			}
			case 401: {
				setToastMessage(ToastMessages.INVALID_API_MISSING_KEY);
				break;
			}
			case 200:
			case 500:
			default: {
				setToastMessage(ToastMessages.GENERAL_ERROR);
				break;
			}
		}
	};
	const validateSendSetting = () => {
		let isValidated: boolean = true;
		let validationErrors: string[] = [];
		if (selectedGroups?.length === 0) {
			validationErrors.push(translator('group.zeroSelected'));
			isValidated = false;
		}
		if (sendType === '1' || sendType === '2' || sendType === '3') {
			if (sendType === '1' && isValidated) {
				isValidated = true;
			}
			if (sendType === '2') {
				if (!sendDate) {
					validationErrors.push(translator('whatsappCampaign.timeAndDate'));
					isValidated = false;
				}
			}
			if (sendType === '3') {
				if (
					!sendTime ||
					daysBeforeAfter === '' ||
					spectialDateFieldID === '0'
				) {
					validationErrors?.push(translator('whatsappCampaign.timeAndDate'));
					isValidated = false;
				}
			}
		} else {
			validationErrors.push(translator('whatsappCampaign.timeAndDate'));
			isValidated = false;
		}
		if (!isValidated) {
			setGroupSendValidationErrors(validationErrors);
			setDialogType({
				type: 'validation'
			})
		}
		return isValidated;
	};

	const onSummarySend = async () => {
		setIsLoader(true);
		setDialogType({ type: '' });
		let sendCampaignPayload: ApiSendCampaignData = {
			WACampaignID: Number(campaignID),
		};
		if (Number(randomlyCount) > 0) {
			sendCampaignPayload.Random = Number(randomlyCount);
		}
		if (campaignID) {
			const { payload: sendCampaignData }: ApiSendCampaign =
				await dispatch<any>(sendCampaign(sendCampaignPayload));
			setIsLoader(false);
			if (sendCampaignData?.StatusCode === 927) {
				// WHATSAPP_CAMPAIGN_SEND, FILE_ATTACHMENT
				setTierMessageCode(sendCampaignData?.Message);
				setDialogType({ type: 'tier' })
			}
			else if (sendCampaignData?.StatusCode === 7 || sendCampaignData?.StatusCode === "7") {
				const matchedTier = tierSetting.find(tier => tier.value === String(campaignSummary?.WhatsappTierID));
				let tierLimit = matchedTier ? matchedTier.messageLimit : 'X';
				if (typeof tierLimit === 'number') {
					tierLimit = tierLimit.toLocaleString('en-US');
				}
				
				setDialogType({ 
					type: 'apiError',
					data: translator('settings.accountSettings.actDetails.fields.metaExceedLimitMessage', { limit: tierLimit })
				});
			}
			else if (sendCampaignData?.Status === apiStatus.SUCCESS) {
				setDialogType({
					type: 'sendCampaignSuccess'
				});
				setRandomlyCount('');
			} else {
				sendCampaignData?.Message
					? setToastMessage({
						...ToastMessages.ERROR,
						message: sendCampaignData?.Message,
					})
					: setToastMessage(ToastMessages.ERROR);
			}
		}
	};

	const onExitCampaign = () => {
		if (FromAutomation) {
			window.location.href = `/Pulseem/CreateAutomations.aspx?AutomationID=${FromAutomation}&NodeToEdit=${NodeToEdit}&fromreact=true&Culture=${isRTL ? 'he-IL' : 'en-US'}`
		} else {
			navigate(whatsappRoutes.CAMPAIGN_MANAGEMENT);
		}
	};

	const getExitDialog = () => ({
		title: translator('whatsappManagement.LeaveCampaignCreation'),
		showDivider: false,
		content: (
			<Typography style={{ fontSize: 18 }} className={clsx(classes.textCenter)}>
				{translator('whatsappManagement.LeaveCampaignCreationDesc')}
			</Typography>
		),
		renderButtons: () => <ConfirmationButtons
			classes={classes}
			onConfirm={async () => {
				await onCampaignSave(true, true, true);
				onExitCampaign();
			}}
			onCancel={() => {
				setDialogType({ type: '', data: '' });
				onExitCampaign();
			}}
		/>
	})

	const getCancelPulseDialog = () => ({
		title: translator('smsReport.pulseCancel'),
		showDivider: false,
		content: (
			<Typography style={{ fontSize: 18 }} className={clsx(classes.textCenter)}>
				{translator('smsReport.confirmCancelPulse')}
			</Typography>
		),
		renderButtons: () => <ConfirmationButtons
			classes={classes}
			onConfirm={() => {
				setPulseData({
					pulseSettingsId: 0,
					pulseAmount: 0,
					timeInterval: 0,
					pulseType: 2,
					random: 0,
					timeType: 1,
					pulsePer: "recipients",
					pulseReci: "",
					minName: "mins",
					hourName: "Hours",
					togglePulse: false,
					toggleRandom: false,
					pulsesOpen: false
				});
				setDialogType({ type: '', data: '' });
			}}
			onCancel={() => setDialogType({ type: '', data: '' })}
		/>
	});

	const getDeleteDialog = () => ({
		title: translator('whatsapp.alertModal.DeleteText'),
		showDivider: false,
		content: (
			<Typography style={{ fontSize: 18 }} className={clsx(classes.textCenter)}>
				{translator('whatsapp.alertModal.DeleteTitle')}
			</Typography>
		),
		renderButtons: () => <ConfirmationButtons
			classes={classes}
			onConfirm={() => onDeleteCampaign()}
			onCancel={() => setDialogType({ type: '', data: '' })}
		/>
	})

	const getValidationDialog = () => ({
		title: translator('whatsappCampaign.sendValidation'),
		showDivider: false,
		content: (
			<ul className={clsx(classes.noMargin, classes.mb20)}>
				{groupSendValidationErrors?.map((requiredField: string, index: number) => (
					<li key={index} className={classes.validationAlertModalLi}>
						{requiredField}
					</li>
				))}
			</ul>
		),
		onConfirm: async () => {
			setDialogType({
				type: '',
				data: ''
			});
		}
	})

	const getExceedDailyLimit = () => ({
		title: translator('settings.accountSettings.actDetails.fields.exceedLimitMpdalMessage'),
		showDivider: false,
		content: (
			<Typography style={{ fontSize: 18 }} className={clsx(classes.textCenter)}>
				{`${translator('settings.accountSettings.actDetails.fields.exceedLimitMpdalTimeMessage')}
					${campaignSummary?.NextAvailableTime
						? moment(campaignSummary?.NextAvailableTime).format(DateFormats.DATE_TIME_24)
						: moment().add(1, 'd').format(DateFormats.DATE_TIME_24)
					}`}
			</Typography>
		),
		onConfirm: async () => {
			setDialogType({
				type: '',
				data: ''
			});
		}
	})

	const getSummary = () => ({
		title: translator('whatsappCampaign.summary'),
		showDivider: false,
		showDefaultButtons: false,
		content: (
			<SummaryModal
				classes={classes}
				campaignName={''}
				fromNumber={''}
				onSummaryModalClose={() => setDialogType({ type: '' })}
				onConfirmOrYes={onSummarySend}
				selectedGroups={selectedGroups}
				selectedFilterGroups={selectedFilterGroups}
				selectedFilterCampaigns={selectedFilterCampaigns}
				sendType={sendType}
				sendDate={sendDate}
				sendTime={sendTime}
				isSpecialDateBefore={isSpecialDateBefore}
				daysBeforeAfter={daysBeforeAfter}
				specialDatedropDown={specialDatedropDown}
				spectialDateFieldID={spectialDateFieldID}
				campaignSummary={campaignSummary}
				randomlyCount={randomlyCount}
				setRandomlyCount={setRandomlyCount}
				resetRandomCount={() => setRandomlyCount('')}
				pulseData={pulseData}
				overrideMediaUrl={dialogType?.overrideMediaUrl}
			/>
		),
		onConfirm: async () => {
			setDialogType({
				type: '',
				data: ''
			});
		}
	})

	const getSendCampaignSuccess = () => ({
		title: translator('campaigns.campaignIsOnItsWay'),
		showDivider: false,
		showDefaultButtons: false,
		content: (
			<SendCampaignSuccess
				classes={classes}
				isFromAutomation={!!FromAutomation}
				onBackToHome={() => navigate(`${sitePrefix}`)}
				onBackToCampaigns={() =>
					navigate(whatsappRoutes.CAMPAIGN_MANAGEMENT)
				}
				onBackToAutomation={() => window.location.href = `/Pulseem/CreateAutomations.aspx?AutomationID=${FromAutomation}&NodeToEdit=${NodeToEdit}&fromreact=true`}
				sendType={sendType}
				sendDate={sendDate}
				sendTime={sendTime}
				spectialDateFieldID={spectialDateFieldID}
				isSpecialDateBefore={isSpecialDateBefore}
				daysBeforeAfter={daysBeforeAfter}
				specialDatedropDown={specialDatedropDown}
			/>
		),
		onConfirm: async () => {
			setDialogType({ type: '' });
		},
		onCancel: () => navigate(whatsappRoutes.CAMPAIGN_MANAGEMENT),
        onClose: () =>  navigate(whatsappRoutes.CAMPAIGN_MANAGEMENT) ,
	})

	const handleGetPlanForFeature = (tierMessageCode: string) => {
		const planName = findPlanByFeatureCode(
			tierMessageCode,
			availablePlans,
			currentPlan.Id
		);
		
		if (planName) {
			return translator('billing.tier.featureNotAvailable').replace('{feature}', translator(TierFeatures[tierMessageCode as keyof typeof TierFeatures] || tierMessageCode)).replace('{planName}', planName);
		} else {
			return translator('billing.tier.noFeatureAvailable');
		}
	};

	const getTierValidationDialog = () => ({
		title: translator('billing.tier.permission'),
		showDivider: false,
		content: (
			<Typography style={{ fontSize: 18 }} className={clsx(classes.textCenter)}>
				{handleGetPlanForFeature(TierMessageCode)}
			</Typography>
		),
		renderButtons: () => (
			<Grid
				container
				spacing={2}
				className={clsx(classes.dialogButtonsContainer, isRTL ? classes.rowReverse : null, !get(subAccount, 'CompanyAdmin', false) ? classes.dNone : '')}
			>
				<Grid item>
					<Button
						onClick={() => {
						setDialogType({});
						setShowTierPlans(true);
					}}
					className={clsx(classes.btn, classes.btnRounded)}
					>
						{translator('billing.upgradePlan')}
					</Button>
				</Grid>
				<Grid item>
					<Button
						onClick={() => setDialogType({})}
						className={clsx(classes.btn, classes.btnRounded)}
					>
						{translator('common.cancel')}
					</Button>
				</Grid>
			</Grid>
		)
	})

	const getApiErrorDialog = () => ({
		title: '',
		showDivider: false,
		customContainerStyle: classes.apiErrorDialogContainer,
		content: (
			<Typography style={{ fontSize: 18 }} className={clsx(classes.textCenter)}>
				{dialogType?.data}
			</Typography>
		),
		onConfirm: async () => {
			setDialogType({ type: '', data: '' });
		}
	});

	const renderDialog = () => {
		const { type } = dialogType || {}
		let currentDialog: any = {};
		if (type === 'exit') {
			currentDialog = getExitDialog();
		} else if (type === 'validation') {
			currentDialog = getValidationDialog();
		} else if (type === 'delete') {
			currentDialog = getDeleteDialog();
		} else if (type === 'exceedDailyLimit') {
			currentDialog = getExceedDailyLimit();
		} else if (type === 'summary') {
			currentDialog = getSummary();
		} else if (type === 'sendCampaignSuccess') {
			currentDialog = getSendCampaignSuccess();
		} else if (type === 'tier') {
			currentDialog = getTierValidationDialog();
		} else if (type === 'cancelPulse') {
			currentDialog = getCancelPulseDialog();
		} else if (type === 'apiError') {
			currentDialog = getApiErrorDialog();
		}

		if (type) {
			return (
				dialogType && <BaseDialog
					classes={classes}
					open={dialogType}
					onCancel={() => setDialogType({})}
					onClose={() => setDialogType({})}
					renderButtons={currentDialog?.renderButtons || null}
					{...currentDialog}>
					{currentDialog?.content}
				</BaseDialog>
			)
		}
	}

	const renderSubHeader = () => {
		return (
				<Title
						Element={(
								<Box className='stepHead'>
										<Stack direction={{ xs: 'column', sm: 'column', md: 'row' }} ml={1} >
												<span className={'stepTitle'}>
														{translator("mainReport.sendSetting")}
												</span>

										</Stack>
								</Box>
						)}
						classes={classes}
						isIcon={false}
						ContainerStyle={{
								padding: 0,
								minHeight: 42,
								height: 'auto',
								overflowY: 'hidden'
						}}
				/>
		)
	}

	return (
		<DefaultScreen
			subPage={'send2'}
			currentPage='whatsapp'
			classes={classes}
			customPadding={true}
			containerClass={classes.editorCont}
		>
			{isAccountSetup ? (
				<Box className={"head"}>
					<Box className={clsx('topSection', classes.mb50)}>
						<Title
							Text={translator('whatsappCampaign.header')}
							classes={classes}
						/>
						<Box className={'containerBody'}>
							{renderSubHeader()}
							<Box className={clsx('bodyBlock', classes.pt20)}>
								<Grid container style={{ marginBottom: '40px' }}>
									<Grid item md={7} xs={12}>
										<LeftPane
											classes={classes}
											fetchPage={fetchGroupsPage}
											reloadToken={groupsReloadToken}
											onSelectAllGroups={onSelectAllGroups}
											onFilterDialogOpen={ensureFilterCampaigns}
											totalRecipients={totalRecipients}
											testGroupList={testGroupList}
											finishedCampaigns={finishedCampaigns}
											selectedGroups={selectedGroups}
											setSelected={setSelectedGroupsManually}
											selectedFilterCampaigns={selectedFilterCampaigns}
											setFilterCampaigns={setFilterCampaigns}
											selectedFilterGroups={selectedFilterGroups}
											setFilterGroups={setFilterGroups}
											onNewGroupChange={setNewGroupName}
											newGroupName={newGroupName}
											onNewGroupSave={onNewGroupSave}
											activeTab={activeTab}
											setActiveTab={setActiveTab}
											onFilter={onFilter}
											isCreateNewGroup={isCreateNewGroup}
											setIsCreateNewGroup={setIsCreateNewGroup}
											onManualUpload={onManualUpload}
											exceptionalDaysToggle={exceptionalDaysToggle}
											exceptionalDays={exceptionalDays}
											setExceptionalDaysToggle={setExceptionalDaysToggle}
											setExceptionalDays={setExceptionalDays}
											showTestGroups={showTestGroups}
											setShowTestGroups={setShowTestGroups}
										/>
									</Grid>
									<Grid item md={1} xs={12}></Grid>
									<Grid item md={4} xs={12}>
										<RightPane
											classes={classes}
											handleDatePicker={handleDatePicker}
											sendDate={sendDate}
											sendTime={sendTime}
											handleRadioTime={handleRadioTime}
											sendType={sendType}
											handleSendType={handleSendType}
											timePickerOpen={timePickerOpen}
											handleTimePicker={handleTimePicker}
											daysBeforeAfter={daysBeforeAfter}
											handleSpecialDayChange={handleSpecialDayChange}
											spectialDateFieldID={spectialDateFieldID}
											handleSelectChange={handleSelectChange}
											isSpecialDateBefore={isSpecialDateBefore}
											setIsSpecialDateBefore={setIsSpecialDateBefore}
											specialDatedropDown={specialDatedropDown}
											selectedGroups={selectedGroups}
											pulseSendingOpen={() => setPulseData({ ...pulseData, pulsesOpen: true })}
											onCancelPulse={() => setDialogType({ type: 'cancelPulse' })}
											packetSending={
												pulseData.togglePulse ? <span style={{ marginBottom: "5px", marginTop: "5px" }}>
													{translator("smsReport.packetSend")} - {pulseData.pulseAmount} {pulseData.pulsePer === "" || pulseData.pulsePer === "recipients" ? translator("sms.recipients") : translator("common.Percent")} {" "}
													{translator("sms.every")} {pulseData.timeInterval} {pulseData.hourName === "" || pulseData.minName === "mins" ? translator("common.minutes") : translator("common.hours")}
												</span> : <></>
											}
											randomSending={
												pulseData.toggleRandom ?
													<span>{translator("smsReport.randomSend")} - {pulseData.random} {translator("smsReport.randomRecipients")}</span>
												: <></>
											}
										/>
									</Grid>
								</Grid>
							</Box>
							<Buttons
								classes={classes}
								onFormButtonClick={onFormButtonClick}
								displayBackButton={true}
								showSendButton={FromAutomation ? (!!FromAutomation && !isSendCampaign) : true}
								showContinueButton={FromAutomation ? (!!FromAutomation && !!isSendCampaign) : false}
								isSummary={!FromAutomation}
							/>
						</Box>
					</Box>
					{renderToast()}
				</Box>
			) : (
				!isLoader && <NoSetup classes={classes} />
			)}
			{renderDialog()}
			<Loader isOpen={isLoader} showBackdrop={true} />
			{
        <Pulse
          classes={classes}
          selectedGroups={selectedGroups}
          totalRecipients={totalRecipients}
          onClose={(pulseResponse: any) => {
            if (pulseResponse !== null) {
							setPulseData({
								...pulseData,
								pulseAmount: pulseResponse?.pulseAmount,
								timeInterval: pulseResponse?.timeInterval,
								pulseType: pulseResponse?.pulseType,
								random: pulseResponse?.random,
								timeType: pulseResponse?.timeType,
								pulsePer: pulseResponse?.pulsePer,
								pulseReci: pulseResponse?.pulseReci,
								minName: pulseResponse?.minName,
								hourName: pulseResponse?.hourName,
								togglePulse: pulseResponse?.togglePulse,
								toggleRandom: pulseResponse?.toggleRandom,
								pulsesOpen: false,
							});
            } else {
							setPulseData({
								...pulseData,
								pulsesOpen: false,
							})
						}
          }}
          isOpen={pulseData.pulsesOpen}
          initialValues={{
            pulseAmount: pulseData.pulseAmount,
            timeInterval: pulseData.timeInterval,
            pulseType: pulseData.pulseType,
            random: pulseData.random,
            timeType: pulseData.timeType,
            pulsePer: pulseData.pulsePer,
            pulseReci: pulseData.pulseReci,
            minName: pulseData.minName,
            hourName: pulseData.hourName,
            togglePulse: pulseData.togglePulse,
            toggleRandom: pulseData.toggleRandom,
          }}
        />
      }
			{showTierPlans && <TierPlans
					classes={classes}
					isOpen={showTierPlans}
					onClose={() => setShowTierPlans(false)}
			/>}
		</DefaultScreen>
	);
};

export default SendCampaign;
